/*
 * 项目进度日志组件
 * zxw
 * 创建时间：
 * 修改时间：2026-07-09
*/

import React, { useState, useEffect, useCallback, useMemo } from 'react';
import $ from 'jquery';
import CNF from '../../incs/Config.js';
import {
    theme,
    message,
    Table,
    Select,
    Button,
    Progress,
    Tooltip,
    Space,
    DatePicker,
    Tag,
} from 'antd';
import { generate } from '@ant-design/colors';
import { ExportOutlined } from '@ant-design/icons';
import {
    UjoinParams,
    AddRequestHeaders,
    DateFormat,
    ShowIPModal,
    GetArrSpanMaxWidth,
    GetDropdownActionName,
} from '../../incs/FunHelper.js';
import ExportJsonExcel from 'js-export-excel';

import DetailProgressEntity from './DetailProgressLogEntity.js';

const MODULENAME = CNF.navItems[0].submenu[3].name.replace('管理', '');
const MODULENAME_PTN = CNF.navItems[0].submenu[3].ptn;
const MODULENAME_URL = CNF.navItems[0].submenu[3].url;

const { RangePicker } = DatePicker;

const twoColors = {
    '0%': '#108ee9',
    '100%': '#87d068',
};

const Lists = (props) => {
    const { btnLists, dataLists, currentIndex, pageCount, changeIndex, refresh, preGroup } = props;

    const {
        token: {
            pageSize,
        },
    } = theme.useToken();

    const [record, setRecord] = useState(null);
    const [open, setOpen] = useState(false);

    const update = useCallback((open, record = null) => {
        setRecord(record);
        setOpen(open, record);
    }, [setOpen]);

    /**
     * 操作选项
     * @param {*} action 
     * @param {*} record 
    */
    const operation = useCallback((action, record) => {
        const uri = MODULENAME_URL.slice(1) + '/' + record.key;
        switch (action) {
            case CNF.actionName.UPDATE:
                update(true, record);
                break;
            case CNF.actionName.DELETE:
                ShowIPModal(record.key, record.rolename, action, MODULENAME, refresh, uri);
                break;
            default:
                break;
        }
    }, [refresh, update]);

    const hasOpPerm = (
        btnLists.indexOf(MODULENAME_PTN + '_update') > 0 ||
        btnLists.indexOf(MODULENAME_PTN + '_delete') >= 0
    );

    const columns = useMemo(() => [
        { title: '', dataIndex: '', key: 'key', fixed: 'left', width: CNF.searchMarginLeft * 4, },
        { title: '项目名称', dataIndex: 'project_name', key: 'project_name', fixed: 'left', width: GetArrSpanMaxWidth(dataLists, 'project_name'), },
        { title: '项目阶段', dataIndex: 'phase', key: 'phase', width: 120, },
        {
            title: '项目进度', key: 'progress', width: 180,
            render: (record) => <Progress style={{ margin: 0, width: '80%' }} size='small' percent={record.progress} strokeColor={twoColors} />
        },
        {
            title: '进度状态', key: 'node_status', width: 120,
            render: (record) => <Tag style={{ width: 52, color: record.node_color, textAlign: 'center' }} variant='filled' size='small' color={generate(record.node_color)[0]}>{record.node_status}</Tag>
        },
        {
            title: '进度说明', key: 'description', minWidth: 200, maxWidth: 300, ellipsis: true,
            render: (record) => < Tooltip placement='top' title={< span > {record.description}</span >}>{record.description}</Tooltip >
        },
        { title: '记录时间', dataIndex: 'record_time', key: 'record_time', width: CNF.tableCreateTimeColumnWidth, },
        { title: '记录者', dataIndex: 'create_displayname', key: 'create_displayname', width: CNF.tableCreateDisplayeColumnWidth, },
        {
            title: '', key: 'operation', fixed: 'right', width: CNF.tableOperationColumnWidth, hidden: !hasOpPerm,
            render: (record) => GetDropdownActionName(btnLists, MODULENAME_PTN, record, operation)
        }
    ], [btnLists, hasOpPerm, operation, dataLists]);

    return (
        <>
            <Table
                columns={columns}
                size='middle'
                dataSource={dataLists}
                pagination={{
                    showSizeChanger: false,
                    showQuickJumper: false,
                    showTotal: () => `共${pageCount > 10000 ? (pageCount / 10000).toFixed(CNF.DPL) + '万' : pageCount}条`,
                    pageSize: pageSize,
                    current: currentIndex,
                    total: pageCount,
                    onShowSizeChange: (current, pageSize) => props?.changePageSize(pageSize, current),
                    onChange: (current) => changeIndex(current),
                }}
            />
            {
                record && <DetailProgressEntity
                    refresh={refresh}
                    preGroup={preGroup}
                    btnLists={btnLists}
                    open={open}
                    setOpen={update}
                    record={record}
                    action={CNF.actionName.UPDATE}
                />
            }
        </>
    );
}

const ProjectLog = (props) => {
    const { btnLists, preGroup } = props;

    const { token: { pageSize, }, } = theme.useToken();

    const [loading, setLoading] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();
    const [triggerRefresh, setTriggerRefresh] = useState(0);
    const [currentIndex, setCurrentIndex] = useState(1);
    const [pageCount, setPageCount] = useState(0);
    const [dataLists, setDataLists] = useState([]);
    const refresh = useCallback(() => {
        setTriggerRefresh((prev) => prev + 1);
    }, []);

    const [projectLists, setProjectLists] = useState([]);
    const [projectUlid, setProjectUlid] = useState('');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');

    const changeIndex = useCallback((index) => {
        setCurrentIndex(index);
    }, []);

    const handleProjectUlidChange = useCallback((value) => {
        setProjectUlid(value || undefined);
        setCurrentIndex(1);
    }, []);
    const handleTimeIntervalChange = useCallback((_, dateString) => {
        setStartDate(dateString ? dateString[0] : '');
        setEndDate(dateString ? dateString[1] : '');
        setCurrentIndex(1);
    }, []);

    useEffect(() => {
        /***
         * 获取项目下拉列表
         */
        const projectDDList = () => {
            const params = {
                rss: 'list',
                page_size: CNF.maxPageSize,
                current_index: 1
            };
            $.ajax({
                url: `${CNF.api}projects/bases${UjoinParams(params)}`,
                headers: AddRequestHeaders(),
                crossDomain: true,
                type: 'GET',
            }).done((data) => {
                if (data.res === 0) {
                    setProjectLists(data.dat || []);
                } else {
                    messageApi.error(data.msg, CNF.messageDuration);
                }
            }).fail((err) => {
                messageApi.error(err.responseJSON?.detail || '请求失败', CNF.messageDuration);
            })
        }
        projectDDList();
    }, [messageApi]);

    useEffect(() => {
        setLoading(true);

        let params = {
            page_size: pageSize,
            current_index: currentIndex,
            project_ulid: projectUlid,
            start_date: startDate,
            end_date: endDate,
        };

        // 注意：如果 0 也是有效值，需要额外处理，但此处页码和数量通常不为0或空
        params = Object.fromEntries(
            Object.entries(params).filter(([_, value]) => value !== '' && value !== null && value !== undefined)
        );

        $.ajax({
            url: `${CNF.api}${MODULENAME_URL.slice(1)}${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET',
        }).done((data) => {
            if (data.res === 0) {
                setDataLists(data.dat || []);
                setPageCount(data.cnt || 0);
            } else {
                messageApi.error(data.msg, CNF.messageDuration);
            }
        }).fail((err) => {
            messageApi.error(err.responseJSON?.detail || '请求失败', CNF.messageDuration);
        }).always(() => setLoading(false))
    }, [messageApi, pageSize, currentIndex, triggerRefresh, projectUlid, startDate, endDate]);


    /***
    * 导出为 Excel
    */
    const exportAsExecl = (data) => {
        var date = new Date();
        let option = {};  //    option代表的就是excel文件
        option.fileName = '项目进度日志-' + DateFormat('YYYY-mm-dd', date);  //   excel文件名称
        option.datas = [
            {
                sheetData: data,  //   excel文件中的数据源
                sheetName: '项目进度日志明细',  //  excel文件中sheet页名称
                sheetHeader: [
                    '项目名称',
                    '项目编号',
                    '项目阶段',
                    '项目进度(%)',
                    '进度说明',
                    '记录时间',
                    '进度状态',
                    '记录者'
                ],  //  excel文件中每列的表头名称
            }
        ]
        let toExcel = new ExportJsonExcel(option);  //生成excel文件
        toExcel.saveExcel();  //下载excel文件
    }

    /***
     * 获取导出数据
     */
    const exportGetData = () => {
        let params = {
            page_size: CNF.maxPageSize,
            current_index: 1,
            project_ulid: projectUlid,
            start_date: startDate,
            end_date: endDate,
        };

        // 注意：如果 0 也是有效值，需要额外处理，但此处页码和数量通常不为0或空
        params = Object.fromEntries(
            Object.entries(params).filter(([_, value]) => value !== '' && value !== null && value !== undefined)
        );
        $.ajax({
            url: `${CNF.api}${MODULENAME_URL.slice(1)}${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET',
        }).done((data) => {
            if (data.res === 0) {
                if (data.dat.length > 0) {
                    //  删除非必须字段
                    var d = [];
                    for (let i = 0; i < data.dat.length; i++) {
                        var item = data.dat[i]
                        delete item['key'];
                        delete item['create_username'];
                        delete item['create_time'];
                        delete item['update_time'];
                        delete item['node_color'];
                        d.push(item);
                    }
                    exportAsExecl(d);
                } else {
                    exportAsExecl([]);
                }
            } else {
                messageApi.error(data.msg, CNF.messageDuration);
            }
        }).fail((err) => {
            messageApi.error(err.responseJSON?.detail || '请求失败', CNF.messageDuration);
        })
    }

    // 按钮权限判断
    const hasExport = btnLists.includes(MODULENAME_PTN + '_export');

    return (
        <>
            {contextHolder}
            <Space style={{ padding: CNF.searchMarginLeft * 4 }}>
                <Select
                    showSearch
                    allowClear
                    placeholder='请选择项目'
                    style={{ minWidth: 300 }}
                    onChange={handleProjectUlidChange}
                    filterOption={(input, option) => option.props.children.indexOf(input) >= 0}
                    options={projectLists && projectLists.map((item, index) => ({
                        key: index,
                        value: item.key,
                        label: item.name,
                    }))}
                />
                <RangePicker
                    format='YYYY-MM-DD'
                    placeholder={['开始日期', '结束日期']}
                    style={{ width: '100%' }}
                    onChange={handleTimeIntervalChange}
                />
                {hasExport && (
                    <Button
                        title={CNF.actionName.EXPORT + MODULENAME}
                        color='primary'
                        variant='solid'
                        icon={<ExportOutlined />}
                        onClick={() => {
                            exportGetData();
                        }}>
                        {CNF.actionName.EXPORT}
                    </Button>
                )}
            </Space>
            <Lists
                btnLists={btnLists}
                preGroup={preGroup}
                dataLists={dataLists}
                currentIndex={currentIndex}
                pageCount={pageCount}
                changeIndex={changeIndex}
                refresh={refresh}
                loading={loading}
            />
        </>
    );
}

export default ProjectLog;